import ReasonListPage from './list/'
import ReasonAddPage from './add/'

export default {
  ReasonListPage,
  ReasonAddPage
}
